import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import SessionPanel from './sessionPanel';

export default class SessionList extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    sessions: PropTypes.array.isRequired,
    userId: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    approveSession: PropTypes.func,
    hideSession: PropTypes.func,
    putOnHold: PropTypes.func,
    changeProgram: PropTypes.func,
    changeUser: PropTypes.func,
    clearFound: PropTypes.func
  };

  render () {
    const {
      title,
      sessions,
      userId,
      email,
      approveSession,
      hideSession,
      putOnHold,
      changeProgram,
      changeUser,
      clearFound
    } = this.props;

    return (
      <div>
        <h4>{title}</h4>
        <ReactCSSTransitionGroup
            transitionName="unapproved-session-list"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={1000}>
          {sessions.length ? sessions.map(session => {
            const { sessionId } = session;
            return (
              <SessionPanel
                  key={sessionId}
                  userId={userId}
                  email={email}
                  session={session}
                  approveSession={approveSession}
                  hideSession={hideSession}
                  putOnHold={putOnHold}
                  changeProgram={changeProgram}
                  changeUser={changeUser}
                  clearFound={clearFound}
              />
            );
          }) : <div>None</div>}
        </ReactCSSTransitionGroup>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/staff/sessionList.jsx